/* RESPONSIBLE TEAM: team-messenger */
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default class MessengerSalesRoute extends IntercomRoute {
  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-messenger',
    };
  }
}
